var _defs, _g, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIphoneCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    viewBox: "0 0 582 582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.52;}.cls-2{fill:#fff;}.cls-3{font-size:92.37px;fill:#ed1c24;}.cls-3,.cls-4{font-family:MicrosoftYaHeiUILight, Microsoft YaHei UI;}.cls-4{font-size:321.51px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 0.5,
    width: 581,
    height: 581,
    rx: 129.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.17,245A128.82,128.82,0,0,1,1222,373.83V696.17A128.82,128.82,0,0,1,1093.17,825H770.83A128.82,128.82,0,0,1,642,696.17V373.83A128.82,128.82,0,0,1,770.83,245h322.34m0-1H770.83A129.83,129.83,0,0,0,641,373.83V696.17A129.83,129.83,0,0,0,770.83,826h322.34A129.83,129.83,0,0,0,1223,696.17V373.83A129.83,129.83,0,0,0,1093.17,244Z",
    transform: "translate(-641 -244)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(129.7 130.83)"
  }, "Monday")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(139.49 471.08)"
  }, "01")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneCalendarIcon);
export default __webpack_public_path__ + "static/media/iphone-calendar-icon.397fb629adc7eaeb7f77b6ff1af06c1a.svg";
export { ForwardRef as ReactComponent };